import { Component } from '@angular/core';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { GraphService } from '../../General/graph/graph.service';
import { MessageService } from '../../shared/message.service';
import { GraphExerciseComponent } from '../../shared/interactive-graph/exercise_components/graph-exercise.component';
import { InteractiveGraph } from 'graph-interactive/dist/lib/interactive/interactiveGraph';
import { Weightable, GraphAlgorithm, Interactable } from 'graph-interactive';
import { InteractionType } from 'graph-interactive/dist/lib/interactive/InteractionType';
import { GraphDW } from '../../shared/interactive-graph/simple_graphs/graphDW';
import { AbstractEdge } from 'graph-interactive/dist/lib/abstract/aEdge';

@Component({
  selector: 'app-shortest-path',
  templateUrl: './shortest-path.component.html',
  styleUrls: ['./shortest-path.component.css']
})
export class ShortestPathComponent extends GraphExerciseComponent {


  private readonly canvasID: string = 'graph-canvas';
  private readonly resetPathID: string = 'resetPathButton';

  constructor(protected activatedRoute: ActivatedRoute, protected topicService: TopicService,
    protected messageService: MessageService, graphService: GraphService) {
    super(activatedRoute, topicService, messageService);
    this.printable = true;
    this.type = 'shortestPath';
  }

  // tslint:disable-next-line: use-life-cycle-interface
  ngOnInit() {
    super.ngOnInit();
    window.onload = function () { };
  }

  // tslint:disable-next-line: use-life-cycle-interface
  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.graph.setInteractionType(InteractionType.HIGHLIGHT_SIMPLE_PATH);
    this.graph.initSelected(true);

    const resetPathButton = <HTMLButtonElement>document.getElementById(this.resetPathID);
    resetPathButton.addEventListener('click', this.onResetPath, false);
  }

  onResetPath = () => {
    this.resetPath();
  }

  resetPath() {
    this.graph.resetSelected();
    this.graph.initSelected(true);
    this.graph.forceUpdate();
  }

  initGraph(): InteractiveGraph {
    const canvas = <HTMLCanvasElement>document.getElementById(this.canvasID);
    const g = new SPGraphDW(canvas);
    return g;
  }

  resetState() {
    super.resetState();
    this.graph.resetSelected();
    this.graph.initSelected(true);
    this.graph.forceUpdate();
  }

  setTypeSpecificsFromState() {
  }

  setTypeSpecificsFromConfiguration() {
  }

  checkSolution() {
    const e = this.evaluate();
    if (e[0] === e[1]) {
      this.messageService.addAlertWithTimeout(this.get('correct'), 'success', 10000);
      this.messageService.addAlertWithTimeout(this.get('FoundShortestPath'), 'success', 20000);

      this.solved = true;
      this.state.solved = true;
      this.saveState();

    } else {
      this.messageService.addAlertWithTimeout(this.get('NotFoundShortestPath'),
        'danger', 10000);
    }
  }


  computeState() {
  }

  getPathLength(): number {
    let res = 0;
    if (this.graph != null) {
      if (this.graph.getSelectedEdges() != null) {
        this.graph.getSelectedEdges().forEach(edge => {
          if (Weightable.isWeightable(edge)) {
            res = res + edge.getWeight();
          }
        })
      }
    }

    return res;
  }


  evaluate(): [number, number] {
    const edges = GraphAlgorithm.dijkstraShortestPath(this.graph.getGraph(),
      this.graph.getSourceNode(), this.graph.getTargetNode())[1];
    let expected = 0;
    edges.forEach(edge => {
      if (Weightable.isWeightable(edge)) {
        expected = expected + edge.getWeight();
      }
    })
    const result = (this.getPathLength() <= expected
      && this.graph.getSelectedNodes().includes(this.graph.getTargetNode())) ? 1 : 0;
    return [result, 1];
  }


}

//Specific graph for making edges non interactable
class SPGraphDW extends GraphDW {
  disableHover(interactabe: Interactable): boolean {
    if (interactabe instanceof AbstractEdge) {
      return true;
    }
    return super.disableHover(interactabe);
  }
}